export default __webpack_public_path__ + "static/media/search-ios.ca97ec793c31b2fdf39dfd42f1f37aa1.svg";